import { array } from 'prop-types';
import React, { Component } from 'react';

import * as func from "../../../../../../utils/functions";
import RankingItem from './rankingItem';
import {EDIT_MODE} from "../../../../../../wpconfig"

class PopupJCR extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isEdit: EDIT_MODE.SHOW,
        field: "ranking",
        record : {
          "indicator_type": "jcr",
          "indicator_year": null,
          "edition": null,
          "impact": null,
          "total_cites": null,
          "total_items": null,
          "jif": null,
          "immediacy": null,
          "eigen_factor": null,
          "article_influence": 0,
          "norm_eigen_factor": null,
          "self_cite_ratio": null,
          "half_life_cited": null,
          "half_life_citing": null,
          "impact_5": null,
          "impact_no_self": null,
          "jci": null,
          "correct_impact": null,
          "correct_eigen": null
        },
        pkKey: "ranking_id"
      }
    }
  
    componentDidMount() {
      this.props.indicator_id ?
      func.getData("admin/journal/" + func.getParams("record_id") + "/indicator/" + this.props.indicator_id, {}).then((response) => {
        this.setState({
          record: response.record
        })
      }) : (
        console.log("레코드값.")
      )
    }

    onEditSave = (e) => {
      const { record } = this.state

      if (this.indicator_year.value === '') {
        this.indicator_year.focus();
      } else {
        if (record.indicator_id) {
          func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/" + record.indicator_id + "/update", record).then((response) => {
            if (response.code === 'ok') {
              // this.props.showMessage('수정 되었습니다.')
              this.props.togglePopup()
            } else {
              // this.props.showMessage('수정 실패 : ' + response.message)
            }
          })
        } else {
          // console.log("인서트")
          // console.log(this.props)
          func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/insert", record).then((response) => {
            // console.log(response)
            if (response.code === 'ok') {
              // this.props.showMessage('추가 되었습니다.')
              // record.indicator_id = response.indicator_id
              this.props.togglePopup()
            } else {
              // this.props.showMessage('추가 실패 : ' + response.message)
            }
          })
        }
      }
    };

    onUpdate = () => {
      this.onEditSave()
    }

    onChange = (e) => {
      const { record } = this.state
      record[e.target.name] = e.target.value
      this.setState({ record : record })
    }

    onRankingUpdate = (index, item, render) => {
      const { record } = this.state
      record.ranking[index] = item
      console.log(record)
      this.setState({ record : record })
    }

    onRankingRemove = (index, render) => {
      const { record } = this.state
      record.ranking.splice(index, 1);
      this.setState({ record : record })
    }

    onRankingInsert = () => {
      const { record } = this.state
      if (record[this.state.field].length > 0 && record[this.state.field][0][this.state.pkKey] === '') {
        this.showMessage('추가해주세요.')
      } else {
        const insertRecord = {
          "ranking_id": "",
          "indicator_type": "jcr",
          "category_code": "",
          "category_name": "",
          "category_count": "",
          "ranking": "",
          "percent": "",
          "percentile": "",
          "is_edit" : EDIT_MODE.SHOW_EDIT,
        }
        this.onEditIndex(0);
        // 데이터 변환 체크하기
        record[this.state.field].unshift(insertRecord)
        this.setState({ record : record })
      }
    }

    onEditIndex(id) {
      if(this.state.editIndex)
        this.refs["ref" + this.state.editIndex].onClose();
      else if(this.refs.ref)
        this.refs.ref.onClose();
      else if(this.refs["ref" + this.state.editIndex])
        this.refs["ref" + this.state.editIndex].onClose();
  
      this.setState({
        'editIndex' : id
      })
    }

    render() {

      const { record } = this.state;

        return (
          <>
            <div className="modal d-block pieces_modal PopupJCR" tabIndex="1"> 
              <div className="modal-dialog">
                <div className="modal-content rm">
                  <div className="modal-header">
                    <h5 className="modal-title">JCR Indicator</h5>
                    <button type="button" className="btn-close" onClick={() => this.props.togglePopup()}></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="container-fluid pl-0 pr-0 m-0 detail-wrap">
                        <div className="row mb-2">
                          <div className="col-md-2 form-group field-danger">
                            <label htmlFor="indicator_type"><strong>Indicator Type</strong></label>
                            <input type="text" id="indicator_type" name="indicator_type" className="form-control" readOnly="readOnly" value={ record.indicator_type || 'jcr' } onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="indicator_year"><strong>Year</strong></label>
                            <input type="text" id="indicator_year" name="indicator_year" ref={(ref)=>this.indicator_year=ref} className="form-control" value={ record.indicator_year || '' } placeholder="2021" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="edition"><strong>Edition</strong></label>
                            <input type="text" id="edition" name="edition" className="form-control" value={ record.edition || '' } onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="impact"><strong>Impact</strong></label>
                            <input type="text" id="impact" name="impact" className="form-control" value={ record.impact || '' } placeholder="1.000" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="total_items"><strong>Total Items</strong></label>
                            <input type="text" id="total_items" name="total_items" className="form-control" value={ record.total_items || '' } placeholder="0" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="total_cites"><strong>Total Cites</strong></label>
                            <input type="text" id="total_cites" name="total_cites" className="form-control" value={ record.total_cites || '' } placeholder="0" onChange={this.onChange} />
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-2 form-group">
                            <label htmlFor="jif"><strong>JIF</strong></label>
                            <input type="text" id="jif" name="jif" className="form-control" value={ record.jif || '' } placeholder="0" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="immediacy"><strong>Immediacy</strong></label>
                            <input type="text" id="immediacy" name="immediacy" className="form-control" value={ record.immediacy || '' } placeholder="1.000" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="eigen_factor"><strong>Eigen Factor</strong></label>
                            <input type="text" id="eigen_factor" name="eigen_factor" className="form-control" value={ record.eigen_factor || '' } placeholder="1.00000" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="article_influence"><strong>Article Influence</strong></label>
                            <input type="text" id="article_influence" name="article_influence" className="form-control" value={ record.article_influence || '' } placeholder="1.000" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="norm_eigen_factor"><strong>Norm Eigen Factor</strong></label>
                            <input type="text" id="norm_eigen_factor" name="norm_eigen_factor" className="form-control" value={ record.norm_eigen_factor || '' } placeholder="1.00000" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="self_cite_ratio"><strong>Self Cite Ratio</strong></label>
                            <input type="text" id="self_cite_ratio" name="self_cite_ratio" className="form-control" value={ record.self_cite_ratio || '' } placeholder="0" onChange={this.onChange} />
                          </div>
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-2 form-group">
                          <label htmlFor="half_life_cited"><strong>Half Life Cited</strong></label>
                          <input type="text" id="half_life_cited" name="half_life_cited" className="form-control" value={ record.half_life_cited || '' } placeholder="0" onChange={this.onChange} />
                        </div>
                        <div className="col-md-2 form-group">
                          <label htmlFor="half_life_citing"><strong>Half Life Citing</strong></label>
                          <input type="text" id="half_life_citing" name="half_life_citing" className="form-control" value={ record.half_life_citing || '' } placeholder="0" onChange={this.onChange} />
                        </div>
                        <div className="col-md-2 form-group">
                          <label htmlFor="impact_no_self"><strong>Impact NoSelf</strong></label>
                          <input type="text" id="impact_no_self" name="impact_no_self" className="form-control" value={ record.impact_no_self || '' } placeholder="1.000" onChange={this.onChange} />
                        </div>
                        <div className="col-md-2 form-group">
                          <label htmlFor="impact_5"><strong>5YR Impact</strong></label>
                          <input type="text" id="impact_5" name="impact_5" className="form-control" value={ record.impact_5 || '' } placeholder="1.000" onChange={this.onChange} />
                        </div>
                        <div className="col-md-2 form-group">
                          <label htmlFor="jci"><strong>JCI</strong></label>
                          <input type="text" id="jci" name="jci" className="form-control" value={ record.jci || '' } placeholder="1.000" onChange={this.onChange} />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-2 form-group">
                          <label htmlFor="correct_impact"><strong>보정 IF</strong></label>
                          <input type="text" id="correct_impact" name="correct_impact" className="form-control" value={ record.correct_impact || '' } placeholder="0.00" onChange={this.onChange} />
                        </div>
                        <div className="col-md-2 form-group">
                          <label htmlFor="correct_eigen"><strong>보정 ES</strong></label>
                          <input type="text" id="correct_eigen" name="correct_eigen" className="form-control" value={ record.correct_eigen || '' } placeholder="0.00" onChange={this.onChange} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col d-flex justify-content-end">
                          <button type="button" className="btn btn-sm btn-primary mr-1" onClick={this.onUpdate}>저장</button>
                          <button type="button" className="btn btn-sm btn-secondary" onClick={() => this.props.togglePopup()}>닫기</button>
                        </div>
                      </div>
                    </form>
                    {
                      record[this.state.field] && 
                      (
                        <>
                          <div className="d-flex mt-4 mb-1">
                            <div className="flex-grow-1">
                              <h5 className="">카테고리 랭킹 정보</h5>
                            </div>
                            <div className="btn-group" role="group">
                              <button type="button" className="btn btn-sm btn-primary mr-1" onClick={this.onRankingInsert}>신규</button>
                            </div>
                          </div>
                          <div style={{maxHeight: "300px", overflowY: "auto"}}>
                            <table className="table table-striped table-thin mb-1 border-bottom">
                              <colgroup>
                                <col width="90px"></col>
                                <col width=""></col>
                                <col width="70px"></col>
                                <col width="70px"></col>
                                <col width="80px"></col>
                                <col width="60px"></col>
                                <col width="80px"></col>
                                <col width="80px"></col>
                                <col width="80px"></col>
                                <col width="90px"></col>
                              </colgroup>
                              <thead>
                              <tr>
                                <th className="pt-2 pb-2">코드</th>
                                <th>카테고리</th>
                                <th>Edition</th>
                                <th>랭킹유형</th>
                                <th>총 저널 수</th>
                                <th>랭킹</th>
                                <th>Percent</th>
                                <th>Percentile</th>
                                <th>Quartile</th>
                                <th>Action</th>
                              </tr>
                              </thead>
                              <tbody>                    
                                {
                                  record[this.state.field] ?
                                  record[this.state.field].map((rData, index) => {
                                    return (
                                      <RankingItem 
                                        key={rData[this.state.pkKey]}
                                        index={rData[this.state.pkKey]}
                                        ref={"ref" + rData[this.state.pkKey]}
                                        indicator_id={record.indicator_id}
                                        arrIndex={index}
                                        pkKey={this.state.pkKey}
                                        record={rData}
                                        onUpdate={this.onRankingUpdate}
                                        onRemove={this.onRankingRemove}
                                        // onReload={this.onReload}
                                        onEditIndex={this.onEditIndex}
                                        // showMessage={this.showMessage}
                                      />
                                    )
                                  }) : 
                                  <tr>
                                    <td colSpan="7" className="center">
                                      랭킹 정보가 없습니다.
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </>
                      )
                    }
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-sm btn-secondary" onClick={() => this.props.togglePopup()}>닫기</button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
    }
}

export default PopupJCR;
